package com.tovtalk.data.analytics

import com.tovtalk.utils.serialization.KotlinInstantSerializer
import kotlin.time.Instant
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonClassDiscriminator

enum class StartedFrom { FEED, PROFILE, SEARCH, HASHTAG, NOTIFICATION, DIRECT }
enum class ExitReason { SWIPE_NEXT, SWIPE_PREV, APP_BACKGROUND, PROFILE_CLICK, NAVIGATION_AWAY, APP_KILL, OTHER }
enum class InteractionType {
    SHARE, PROFILE_CLICK, FOLLOW_FROM_VIDEO, HASHTAG_CLICK,
    REPORT, NOT_INTERESTED, COMMENT_PANEL_OPENED
}

// Snake_case wire format is handled by JsonNamingStrategy.SnakeCase in the Json instance (kotlinx-serialization >= 1.5).
// The type discriminator uses @JsonClassDiscriminator("type") + @SerialName on each subclass.
@OptIn(ExperimentalSerializationApi::class)
@Serializable
@JsonClassDiscriminator("type")
sealed class AnalyticsEvent {
    abstract val eventId: String
    abstract val postId: Long
    @Serializable(with = KotlinInstantSerializer::class)
    abstract val clientTs: Instant

    @Serializable
    @SerialName("video_session")
    data class VideoSessionEvent(
        override val eventId: String,
        val sessionId: String,
        override val postId: Long,
        @Serializable(with = KotlinInstantSerializer::class)
        val sessionStartTs: Instant,
        @Serializable(with = KotlinInstantSerializer::class)
        val sessionEndTs: Instant,
        val watchTimeMs: Long,
        val videoDurationMs: Long,
        val maxPositionMs: Long,
        val loopsCount: Int = 0,
        val pauseCount: Int = 0,
        val seekCount: Int = 0,
        val soundOnMs: Long = 0,
        val soundOffMs: Long = 0,
        val startedFrom: String,
        val exitReason: String,
        val isHeartbeat: Boolean = false,
        @Serializable(with = KotlinInstantSerializer::class)
        override val clientTs: Instant,
    ) : AnalyticsEvent()

    @Serializable
    @SerialName("interaction")
    data class InteractionEvent(
        override val eventId: String,
        val interactionType: String,
        override val postId: Long,
        val videoPositionMs: Long? = null,
        val payload: Map<String, String>? = null,
        @Serializable(with = KotlinInstantSerializer::class)
        override val clientTs: Instant,
    ) : AnalyticsEvent()
}
